export default {"src":"/_next/static/media/college11.fd2093ac.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};